export default __webpack_public_path__ + "assets/images/a2a3a5e0f93e4a2b337704ed44941df8.svg";